import React, { useContext } from 'react'

import { CashflowEventsContext } from '../../context'
import { IndividualEventForm } from './IndividualEventForm'
import { JointEventForm } from './JointEventForm'

export const EventForm = () => {
  const context = useContext(CashflowEventsContext)
  const { state } = context
  const { joint } = state
  return (
    <section className='app-form'>
      {
        joint
          ? <JointEventForm />
          : <IndividualEventForm />
      }
    </section>
  )
}